import radio from '@/lib/radio.js'
import '@/lib/jquery-global.js';

export default function productSelection (node, opts) {
  opts = Object.assign({
    select: '[data-option-select]',
    radio: '[data-option-radio]',
    main: '[data-option-main]',
  }, opts)

  const listeners = []

  const state = {
    id: null,
    options: []
  }

  const selects = slater.qsa(opts.select)
  const radios = slater.qsa(opts.radio)
  const main = slater.qs(opts.main)

  if (!main || !main.length) throw 'data-option-main is missing'
  if (radios.length > 3) throw 'you have more than three radio groups'
  if (selects.length > 3) throw 'you have more than three select inputs'

  const variants = [].slice.call(main.children).reduce((variants, child) => {
    variants[child.innerHTML.replace('&amp;', '&')] = child.value
    return variants
  }, {})

  const inventory_json = JSON.parse(document.querySelector('.js-inventory').innerHTML)
  const add_to_cart = document.querySelector('.js-add-to-cart')

  let sold_out_cover = `
    <div class='absolute z-10 px-2 md:px-4 pin text-center bg-dark-purple js-button-cover flex justify-center items-center' style='background-color: #dadada'>
        <span class='font-medium'>Sold out</span>
    </div>
  `

  selects.forEach(select => {
    if (select.nodeName !== 'SELECT') throw 'data-option-select should be defined on the individual option selectors'

    const index = parseInt(select.getAttribute('data-index'))

    // console.log(index)

    // set initial value
    state.options[index] = select.value

    select.addEventListener('change', e => {

      // console.log(state.options[index])
      // console.log(e.target.value)

      state.options[index] = e.target.value
      updateSelection()
    })
  })

  radios.forEach(r => {
    if (r.nodeName === 'INPUT') throw 'data-option-radio should be defined on a parent of the radio group, not the inputs themselves'

    const index = parseInt(r.getAttribute('data-index'))
    const inputs = [].slice.call(r.getElementsByTagName('input'))

    // set initial value
    inputs.forEach(r => {

      if (r.checked) state.options[index] = r.value
    })

    radio(inputs, value => {
      state.options[index] = value
      updateSelection()
    })
  })

  updateSelection()

  function updateSelection () {

    let keys = Object.keys(variants)
    state.id = variants[state.options.join(' / ')]


    if (typeof state.id !== 'undefined') {
      
    } else {
      const s = keys.find(v => v.includes(state.options[0]))
      state.id = variants[s]
    }

      

      // if (document.querySelector('.js-button-cover')) {
      //   document.querySelector('.js-button-cover').style.display = 'none';
      // } 

      if (document.querySelectorAll('.js-upsell') !== null) {
        var upsells = document.querySelectorAll('.js-upsell');

        upsells.forEach((elem) => {
          elem.classList.remove('active');
        })
      }
    
    
    const inventory = inventory_json[state.id]
   

    if (inventory <= 0) {
      add_to_cart.disabled = true
      add_to_cart.insertAdjacentHTML('beforeend', sold_out_cover)
    } else {
      add_to_cart.disabled = false

      if (document.querySelector('.js-button-cover')) {
        jQuery('.js-button-cover').remove()
      }
    }

      var elems = document.querySelectorAll(".js-shipping-notes");

      elems.forEach((elem) => {
        elem.style.display = 'none';
      })

      var prices = document.querySelectorAll(".js-price");

      prices.forEach((price) => {
        price.style.display = 'none';
      })
      
      jQuery('.js-shipping-notes--' + state.id).show();

      jQuery('.js-price--' + state.id).show();

      if (document.querySelector('.js-upsell--' + state.id) !== null) {
        document.querySelector('.js-upsell--' + state.id).classList.add('active');
      }

      main.value = state.id

      let i = 0;
      for (const value of state.options) {
        if (document.querySelector('.js-selected[data-index="' + i + '"]')) {
          document.querySelector('.js-selected[data-index="' + i + '"]').innerHTML = state.options[i];
          i++; 
        }
      }
    
      let h = jQuery('.slater-product__info--inner').outerHeight()
      jQuery('.slater-product__info').css('min-height', h)
    

      for (let fn of listeners) fn(state)


    
  }

  return {
    get state () {
      return state
    },
    onUpdate (fn) {
      listeners.indexOf(fn) < 0 && listeners.push(fn)
      return () => listeners.splice(listeners.indexOf(fn), 1)
    }
  }
}
